import NetworkingOffers from "./NetworkingOffers";

const Networking = () => {
  return (
    <section className="solution-item-page">
      <NetworkingOffers />
    </section>
  ); 
};

export default Networking;
